import { types, actions, Action } from '.';
import { SagaIterator } from 'redux-saga';
import { put, takeLatest, call } from 'redux-saga/effects';
import * as clinicApi from '../../../api/clinic';
import { actions as appUIActions } from '../../uis/app';
import { actions as workflowActions } from '../../entities/workflow';
import { SubmitClinicInformationResponse } from 'src/models/clinic';
import { increaseAttemptCounter, setAttemptCounter } from 'src/utils/workflow';
import { ProviderInfoResponseStatusCode } from 'src/models/provider';
import { rollbar } from 'src';

export default function* watchClinicData(): SagaIterator {
    yield takeLatest(types.ADD_CLINIC_INFORMATION_ASYNC, addClinicInformationAsync);
}
export function* addClinicInformationAsync(action: Action): SagaIterator {
    try {
        yield put(workflowActions.checkRetry(false));

        const response: SubmitClinicInformationResponse = yield call(clinicApi.submitClinicInformation, action.clinicInformation);
        if (response != undefined) {
            yield put(workflowActions.storeWorkflowData(response.workflow));
        }

        if (response.isPass) {
            setAttemptCounter('0', true);
            yield put(actions.addClinicInformationSucceeded(response.isPass));
            yield put(actions.storeProviderInformationPaymentWithClinic(action.clinicInformation));
            yield put(appUIActions.setMessageIndicator('Submit clinic information successfully, go to the step 04', 'success'));
        } else {
            yield put(actions.updateStatusCode(response.statusCode));
            yield put(workflowActions.checkRetry(true));
            increaseAttemptCounter(true);
            yield call(console.log, 'Add new clinic information failed!');
            yield put(actions.addClinicInformationFailed(response.message));
            if (response.statusCode && (response.statusCode === ProviderInfoResponseStatusCode.Error_TerminatedUser || response.statusCode === ProviderInfoResponseStatusCode.Error_General)) {
                yield put(appUIActions.setMessageIndicator('Cannot add clinic information. ' + response.message, 'error'));
            }
        }
    } catch (e) {
        yield put(actions.updateStatusCode(undefined));
        yield put(workflowActions.checkRetry(true));
        increaseAttemptCounter(true);
        yield put(actions.addClinicInformationFailed(''));
        yield call(console.log, 'Cannot add clinic information. ' + e);
        rollbar.error('Cannot add clinic information!');
    }
}


// WEBPACK FOOTER //
// ./src/modules/entities/clinic/saga.ts